/** 详情页等：生成中不可勾选、不参与 Shift 连选 */
export function isMultiSelectSelectableStatus(status?: string) {
    if (!status) {
        return true;
    }
    return status !== 'progress' && status !== 'processing';
}

/** 首页最近文件：PROCESSING 可参与多选；仅排除遗留 `progress` 态 */
export function isRecentFileMultiSelectSelectableStatus(status?: string) {
    if (!status) {
        return true;
    }
    return status !== 'progress';
}

export function findMultiSelectItemIndex<T extends { id: string | number }>(items: T[], id: string | number) {
    const sid = String(id);
    return items.findIndex(i => String(i.id) === sid);
}

export function computeMultiSelectRangeIds<T extends { id: string | number; status?: string }>(
    items: T[],
    anchorIndex: number,
    targetIndex: number,
    isSelectable: (status?: string) => boolean = isMultiSelectSelectableStatus,
): string[] {
    const lo = Math.min(anchorIndex, targetIndex);
    const hi = Math.max(anchorIndex, targetIndex);
    return items
        .slice(lo, hi + 1)
        .filter(i => isSelectable(i.status))
        .map(i => String(i.id));
}
